var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0855989 11.8574C0.0855989 15.7959 3.29001 19 7.2282 19H9.75656C10.1755 19 10.5151 18.6605 10.5151 18.2415V17.9887C10.5151 17.5697 10.1756 17.2302 9.75656 17.2302H7.2282C4.26578 17.2302 1.85544 14.8198 1.85544 11.8574C1.85544 8.89499 4.26578 6.48465 7.2282 6.48465H11.8929L8.68032 9.6972C8.33527 10.0421 8.33527 10.6036 8.68032 10.9486C9.01513 11.2831 9.59782 11.2826 9.93188 10.9486L14.6548 6.22549C14.822 6.05835 14.9141 5.83612 14.9141 5.59968C14.9141 5.36342 14.822 5.14106 14.6548 4.97401L9.93163 0.250732C9.59757 -0.0835774 9.01437 -0.0835774 8.68027 0.250732C8.33523 0.595568 8.33523 1.15717 8.68027 1.50196L11.8928 4.71476H7.2282C3.29001 4.71476 0.0855989 7.91905 0.0855989 11.8574Z",
    fill: "#5A52C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoIcon);
export default __webpack_public_path__ + "static/media/undoIcon.42f776816ff68d20c46b012aad3ab437.svg";
export { ForwardRef as ReactComponent };